/**
 * validate_sbid-ucs.js - SMS認証を行うページの共通処理を行う
 *     対象チケット : MYSB-1396
 *     build対象
 */
$(function () {

});


// WEBPACK FOOTER //
// ./src/shared/validate_sbid-ucs-common.js